import React, { useCallback } from 'react'

import { AIGenerated, Check, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, number, shape, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import formatPrice from 'Utils/formatPrice'

const TRANSLATION_KEY_PREFIX = 'subscription_upgrade.order_summary'

function LegacyPlanCard({ premiumPlan, locale = 'en' }) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(`${TRANSLATION_KEY_PREFIX}.${key}`, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )

  const showOriginalPrice = Boolean(premiumPlan.originalPrice)
    && premiumPlan.originalPrice !== premiumPlan.currentPrice

  return (
    <div className="order-summary__plan">
      <div className="order-summary__plan-content">
        <span className="order-summary__plan-name cgt-body-base-semibold">
          {translate('plan_name')}
          <Icon svgComponent={AIGenerated} size="small" notSpaced />
        </span>
        <span className="order-summary__plan-cadence cgt-caption">
          {translate('plan_cadence')}
        </span>
        <ul className="order-summary__features">
          {(premiumPlan.features || []).map((feature) => (
            <li key={feature} className="order-summary__feature">
              <Icon svgComponent={Check} size="small" notSpaced />
              <span className="order-summary__feature-text cgt-caption">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="order-summary__plan-pricing">
        <span className="order-summary__billing-period cgt-caption-semibold">
          {translate('billing_period')}
        </span>
        <div className="order-summary__price-wrap">
          {showOriginalPrice && (
            <span className="order-summary__original-price cgt-body-base-semibold">
              {formatPrice(premiumPlan.originalPrice)}
            </span>
          )}
          <span className="order-summary__current-price cgt-body-lg-semibold">
            {formatPrice(premiumPlan.currentPrice)}
          </span>
        </div>
        <span className="order-summary__price-unit cgt-caption-semibold">
          {premiumPlan.priceUnit}
        </span>
      </div>
    </div>
  )
}

LegacyPlanCard.propTypes = {
  premiumPlan: shape({
    features: arrayOf(string),
    originalPrice: number,
    currentPrice: number,
    priceUnit: string,
  }).isRequired,
  locale: string,
}

export default LegacyPlanCard
